module.exports = __webpack_public_path__ + "static/media/thumbnail.a7bc03ec.jpg";